module.exports = __webpack_public_path__ + "img/drug_enforcement-stage_3.2.b2c4822d.jpg";